export default __webpack_public_path__ + "static/media/ic_logo.63effbdf.svg";